/* eslint-disable import/first */
import React, { useState, useEffect } from 'react';
import union from 'lodash/union';
import compact from 'lodash/compact';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import { BsMap } from '@react-icons/all-files/bs/BsMap';
import { GrList } from '@react-icons/all-files/gr/GrList';
import InputBase from '@material-ui/core/InputBase';
import Hreflang from '../../components/Hreflang';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { RiSearchLine } from '@react-icons/all-files/ri/RiSearchLine';
import { RiCloseLine } from '@react-icons/all-files/ri/RiCloseLine';
const { selectDesktop } = Slices.appSlice;
const { selectStoreIds, selectStoreEntities } = Slices.storeSlice;
const { selectEntities } = Slices.citySlice;
const { selectCurrentCountry } = Slices.profileSlice;
import Header from '../../components/Header';
import StoreItem from './StoreItem';
import LanguageButton from '../../components/LanguageButton';
const { selectOrderModesByCountry } = Slices.configSlice;
import { FormattedMessage, useIntl } from 'react-intl';
import StoreMap from './StoreMap';
import SeoTitle from '../../components/SeoTitle';
import css from './index.module.scss';
import ClassNames from 'classnames';

function StoreLocator() {
  const isDesktop = useSelector(selectDesktop);
  const allStores = useSelector(selectStoreIds);
  const storeListEntities = useSelector(selectStoreEntities);
  const [storeList, setStoreList] = useState(allStores);
  const [modeTabIndex, setModeTabIndex] = useState(0);
  const [displayMap, setDisplayMap] = useState(false);
  const [citySelect, setCitySelect] = useState('');
  const country = useSelector(selectCurrentCountry);
  const [searchWord, setSearchWord] = useState('');
  const orderModes = useSelector((state) => selectOrderModesByCountry(state, country));
  const [disablePlaceOrder, setDisablePlaceOrder] = useState(false);
  const [storeMode, setStoreMode] = useState(null);
  const [zoom] = useState(0);
  const cityList = useSelector(selectEntities);
  const intl = useIntl();
  const performSearch = ({ list, storeObj, city, mode, keyword }) => {
    const modeMapping = {
      CARHOP: 'carHop',
      DELIVERY: 'del',
      STORE: 'tak',
      DINEIN: 'din',
      DRIVETHRU: 'driveThru',
    };
    let cityResult = [...list];
    if (city !== '') {
      cityResult = compact(
        cityResult.map((el) => {
          const storeDetail = storeObj[el];
          const cityval = city !== '' ? city.split('_')[0] : 0;
          if (cityval !== '' && storeDetail.cityId === +cityval) {
            return el;
          }
        })
      );
    } else {
      cityResult = [...list];
    }
    // eslint:fix map is replaced with forEach
    if (mode?.type) {
      cityResult = compact(
        cityResult.map((el) => {
          const storeDetail = storeObj[el];
          if (mode?.type && storeDetail.services[modeMapping[mode.type]]) {
            return el;
          }
        })
      );
    }
    if (keyword !== '')
      cityResult = compact(
        cityResult.map((el) => {
          const storeDetail = storeObj[el];
          const nameStore = `name_${intl.locale.toLowerCase()}`;
          if (
            keyword &&
            storeDetail[nameStore].toLowerCase().includes(
              keyword
                .replace(/\s{2,}/g, ' ')
                .trim()
                .toLowerCase()
            )
          ) {
            return el;
          }
        })
      );

    return union(cityResult);
  };
  useEffect(() => {
    if (citySelect !== '' || searchWord !== '' || modeTabIndex !== 0) {
      const results = performSearch({
        list: allStores,
        storeObj: storeListEntities,
        city: citySelect,
        mode: storeMode,
        keyword: searchWord,
      });
      setStoreList(results);
    } else {
      setStoreList(allStores);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [citySelect, modeTabIndex, searchWord, storeMode]);

  useEffect(() => {
    const usableOrderModes = orderModes.filter(
      (orderMode) => orderMode.type != 'DELIVERY' && orderMode.enable
    ).length;
    if (usableOrderModes < 1) setDisablePlaceOrder((prev) => true);
  }, [orderModes]);

  const handleChange = (event) => {
    setCitySelect(event.target.value);
  };

  const handleOrderModeChange = (event, newValue) => {
    setModeTabIndex(newValue);
    setStoreMode(orderModes[newValue - 1]);
  };
  const removeSearch = () => {
    setSearchWord('');
    setStoreList(allStores);
  };
  const searchStore = (event) => {
    const searchKeyword = event.target.value;
    setSearchWord(searchKeyword);
  };
  const displayMobileMap = () => {
    setDisplayMap((prev) => !prev);
  };
  const cityName = `name_${intl.locale}`;

  return (
    <Grid className={css.root}>
      <SeoTitle id="storelocator" />
      <Hreflang page="storelocator" />
      <Header
        title={<FormattedMessage id="storeLocator_heading" defaultMessage="Find a Nearby KFC" />}
        actionButtons={[<LanguageButton />]}
      />
      <div className={css.wrapper}>
        {isDesktop && (
          <div className={css.pageHeading}>
            <FormattedMessage id="storeLocator_heading" defaultMessage="Find a Nearby KFC" />
          </div>
        )}

        <div className={css.storeWrapper}>
          <div className={css.storeList}>
            <div className={css.listHeader}>
              <div className={css.inputSearch}>
                <InputBase
                  placeholder={intl.formatMessage({
                    id: 'category_search',
                    defaultMessage: 'Search',
                  })}
                  value={searchWord}
                  inputProps={{ 'aria-label': 'search google maps' }}
                  className={css.locationInput}
                  onChange={(e) => searchStore(e)}
                />
                <IconButton>
                  <RiSearchLine />
                </IconButton>
                {searchWord.length ? (
                  <IconButton type="submit" className={css.iconButton} aria-label="search">
                    <RiCloseLine onClick={removeSearch} className={css.searchClose} />
                  </IconButton>
                ) : (
                  ''
                )}
              </div>
              <div className={css.citySearch}>
                <Select
                  value={citySelect}
                  label="City"
                  displayEmpty
                  className={css.citySelect}
                  onChange={handleChange}
                >
                  <MenuItem className={css.selectBoxItem} value="">
                    <FormattedMessage id={`carhop_city`} defaultMessage="city" />
                  </MenuItem>
                  {Object.entries(cityList).map(([cityKey, cityVal]) => {
                    return (
                      <MenuItem className={css.selectBoxItem} value={cityVal.id}>
                        {cityVal[cityName]}
                      </MenuItem>
                    );
                  })}
                </Select>
              </div>
            </div>
            <div className={ClassNames(css.tabs, { [css.stickyMobileView]: displayMap })}>
              <nav className={css.tabsContainer}>
                <Tabs
                  variant="scrollable"
                  onChange={handleOrderModeChange}
                  indicatorColor="primary"
                  value={modeTabIndex}
                  scrollButtons="off"
                  className={css.tabsBar}
                >
                  <Tab
                    label={intl.formatMessage({
                      id: 'storeLocator_all',
                      defaultMessage: 'All',
                    })}
                    // className={css.tab}
                    className={ClassNames(css.tab, { active: modeTabIndex === 0 })}
                  ></Tab>
                  {orderModes.map((orderMode, idx) => {
                    const title = intl.locale === 'en' ? orderMode.name : orderMode.nameAr;
                    if (!orderMode.enable || !orderMode.visible) {
                      return '';
                    }
                    const currentTab = idx + 1;
                    return (
                      <Tab
                        label={title}
                        // eslint:fix
                        className={ClassNames(css.tab, { active: currentTab === modeTabIndex })}
                      ></Tab>
                    );
                  })}
                </Tabs>
              </nav>
              <div className={css.mobileMapViewAction}>
                <div className={css.resultList}>
                  {intl.formatMessage(
                    { id: 'storeLocator_showingResult' },
                    { result: storeList.length }
                  )}
                </div>
                {!displayMap ? (
                  <Button
                    startIcon={<BsMap />}
                    onClick={displayMobileMap}
                    variant="outlined"
                    className={css.showMapButton}
                    color="primary"
                  >
                    <FormattedMessage id="storeLocator_showMap" defaultMessage="Show Map" />
                  </Button>
                ) : (
                  <Button
                    startIcon={<GrList />}
                    onClick={displayMobileMap}
                    variant="outlined"
                    className={css.showMapButton}
                    color="primary"
                  >
                    <FormattedMessage id="storeLocator_viewList" defaultMessage="View List" />
                  </Button>
                )}
              </div>
            </div>

            <div className={ClassNames(css.storeListing, { [css.hideList]: displayMap })}>
              {storeList.map((el) => {
                return <StoreItem disablePlaceOrder={disablePlaceOrder} zoom={zoom} storeId={el} />;
              })}
            </div>
          </div>
          <div className={ClassNames(css.storeMap, { [css.activeMap]: displayMap })}>
            <StoreMap refineStoreList={storeList} />
          </div>
        </div>
      </div>
      <footer className={css.footer}></footer>
    </Grid>
  );
}

export default StoreLocator;
